import { useLocation } from 'react-router-dom'
import { useRef, useEffect } from 'react'

export const ScrollAssist = () => {
    const location = useLocation()
    const lastHash = useRef('')

    // listen to location change using useEffect with location as dependency
    // https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen

    useEffect(() => {
        let hash = 'root'
        if (location.hash) {
            hash = location.hash.slice(1) // safe hash for further use after navigation
        }

        if (hash && document.getElementById(hash)) {
            setTimeout(() => {
                document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
                lastHash.current = ''
            }, 50)
        }
    }, [location])

    return null
}

ScrollAssist.displayName = 'ScrollAssist'
